import { combineReducers } from "redux";
import { login } from "./loginReducer";

const authReducers = combineReducers({
  user: login
});

export default authReducers;
